import { useEffect, useState } from 'react';
import Product1 from '../Img/Product1.png'
import Product2 from '../Img/Product2.png'
import Product3 from '../Img/Product3.png'
import { useNavigate } from 'react-router-dom';
import Checkout from './Checkout';
import decryptCookieData from './Functions/decryptCookieData';
import { toast, ToastContainer } from 'react-toastify';
import EmptyCartImg from "../Img/EmptyCartImg.png"

// const products = [
//     {
//         id: 1, 
//         name: 'Product Name 1',
//         img: Product1,
//         deliveryStart: '27 March 2025',
//         deliveryEnd: '30 March 2025',
//         discountPrice: 100.00,
//         originalPrice: 200.00
//     },
//     {
//         id: 2,
//         name: 'Product Name 2',
//         img: Product2,
//         deliveryStart: '28 March 2025',
//         deliveryEnd: '31 March 2025',
//         discountPrice: 120.00,
//         originalPrice: 220.00
//     },
//     {
//         id: 3,
//         name: 'Product Name 3',
//         img: Product3,
//         deliveryStart: '29 March 2025',
//         deliveryEnd: '1 April 2025',
//         discountPrice: 150.00,
//         originalPrice: 250.00
//     }
// ];
const getDeliveryDate = (days) => {
    const date = new Date();
    date.setDate(date.getDate() + Number(days));
    return date.toLocaleDateString('en-IN', {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
    }); // Example: "18 May 2025"
};


const Cart = ({ cartItemsLength, setCartItemLength, fetchCart1, paybutton }) => {
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(false);
    const [couponCode, setCouponCode] = useState("");
    const [products, setProducts] = useState([]);
    const userData = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || "";

    const [checkoutForm, setCheckoutForm] = useState({
        name: "",
        phone: "",
        email: "",
        description: ""
    });
    const [mobileError, setMobileError] = useState('');
    const [showCheckoutModal, setShowCheckoutModal] = useState(false);
    const [loading, setLoading] = useState(false)
    const [whatsAppNumber, setWhatsAppNumber] = useState()


    const supportFetch = async () => {
        try {
            const response = await fetch(`${url}/help/single/${process.env.REACT_APP_PERFUME_ID}`);
            const res = await response.json();
            setWhatsAppNumber(res.help.whatsapp_number)
        } catch (error) {
            console.error(error)
        }
    }


    const [discount, setDiscount] = useState(0);
    const url = process.env.REACT_APP_API_URL

    const applyCoupon = async () => {
        if (!couponCode.trim()) {
            toast.warn("Please enter a coupon code");
            return;
        }

        try {
            const response = await fetch(`${url}/coupon/check/${couponCode}?user_id=${process.env.REACT_APP_PERFUME_ID}`);
            const result = await response.json();

            if (response.ok && result.couponData) {
                toast.success(result.message);

                // ✅ Use correct original total
                const originalTotal = products.reduce((acc, p) => acc + Number(p.product_saleprice), 0);
                let discountAmt = 0;
                if (result.couponData.percentage_offer) {
                    discountAmt = (originalTotal * result.couponData.percentage_offer) / 100;
                } else if (result.couponData.price_offer) {
                    discountAmt = result.couponData.price_offer;
                }

                setDiscount(discountAmt);
            }
            else {
                toast.error(result.message || "Invalid coupon");
            }
        } catch (error) {
            console.error("Coupon check failed:", error);
            toast.error("Error checking coupon");
        }

        setIsOpen(false);
    };
    useEffect(() => {
        const user = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || ""
        if (user && user.user_id) {
            fetchCart(user.user_id);
        } else {
            const guestCart = JSON.parse(localStorage.getItem('guest_cart')) || [];
            setProducts(guestCart);
        }
    }, []);

    const safeParse = (val, fallback = {}) => {
        try {
            return typeof val === "string" ? JSON.parse(val) : val || fallback;
        } catch (err) {
            return fallback;
        }
    };

    const fetchCart = async (user_id) => {
        try {
            const response = await fetch(`${url}/cart/${user_id}`);
            const result = await response.json();
            if (!result.isError) {
                const parsed = result.data.map(p => ({
                    ...p,
                    variation_attributes: safeParse(p.variation_attributes, {}),
                    product_gallery: safeParse(p.product_gallery, []),
                }));
                setProducts(parsed);
            } else {
                toast.error("Failed to fetch cart");
            }
        } catch (error) {
            console.error("Fetch cart error:", error);
            toast.error("Error fetching cart");
        }
    };

    const handleMobileChange = (e) => {
        let input = e.target.value.replace(/\s|-/g, ''); // Remove spaces and dashes

        // Remove +91
        if (input.startsWith('+91')) {
            input = input.slice(3);
        }

        // Remove leading 91 (only if more than 10 digits)
        if (input.startsWith('91') && input.length > 10) {
            input = input.slice(2);
        }

        // Remove leading 0
        if (input.startsWith('0')) {
            input = input.slice(1);
        }

        // Allow only digits
        input = input.replace(/\D/g, '');

        // Trim to 10 digits max
        if (input.length > 10) {
            input = input.slice(0, 10);
        }

        setCheckoutForm(prev => ({ ...prev, mobile: input }));

        // Validation
        if (input.length !== 10) {
            setMobileError('Please enter a valid 10-digit mobile number');
        } else {
            setMobileError('');
        }
    };


    const handleRemoveProduct = async (productId) => {
        if (userData?.user_id) {
            // Logged-in: remove from backend
            try {
                const response = await fetch(`${url}/cart/${productId}`, {
                    method: "DELETE"
                });
                const res = await response.json();
                if (!res.isError) {
                    setProducts(prev => prev.filter(p => p.product_sku !== productId));
                    await fetchCart1(userData?.user_id)
                    toast.success("Product removed from cart");
                } else {
                    toast.error("Failed to remove product");
                }
            } catch (err) {
                console.error("Error removing cart item:", err);
                toast.error("Something went wrong");
            }
        } else {
            // Guest: remove from localStorage
            const updatedCart = (JSON.parse(localStorage.getItem("guest_cart")) || []).filter(
                item => item.product_sku !== productId
            );
            localStorage.setItem("guest_cart", JSON.stringify(updatedCart));
            setProducts(updatedCart);
            setCartItemLength(updatedCart.length)
            toast.success("Product removed from cart");
        }
    };



    const handleAskQuote = async () => {
        setLoading(true)
        const payload = {
            coupon_code: couponCode || null,
            discountprice: discount,
            amountbeforediscount
                : products.reduce((acc, p) => acc + Number(p.product_price), 0),
            amountafterdiscount: (products.reduce((acc, p) => acc + Number(p.product_saleprice), 0) - discount).toFixed(2),
            couponapplied: !!discount,
            cart_products: products,
            main_id: process.env.REACT_APP_PERFUME_ID,
            name: checkoutForm.name,
            mobile: checkoutForm.mobile,
            email: checkoutForm.email,
            guestVeg: checkoutForm.guestVeg,
            guestNonVeg: checkoutForm.guestNonVeg,
            description: checkoutForm.description,
            cart_products: products,
            user_id: userData?.user_id,
            user_name: userData?.full_name || checkoutForm.name,
            main_id: process.env.REACT_APP_PERFUME_ID,
            payment_mode: "NA"
        }
        try {
            const response = await fetch(`${url}/payment/getquote`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(payload)
            })
            const res = await response.json();
            if (response.ok) {
                toast.success("Request sent. Our team will contact you shortly.")
                setShowCheckoutModal(false)
                setLoading(false)
                CartEmpty()
                let message = `*Quotation Request Summary*\n\n`;
                message += `*Name:* ${checkoutForm.name}\n`;
                message += `*Mobile:* ${checkoutForm.mobile}\n`;
                message += `*Email:* ${checkoutForm.email}\n`;
                // message += `*Veg Guests:* ${checkoutForm.guestVeg}\n`;
                // message += `*Non-Veg Guests:* ${checkoutForm.guestNonVeg}\n`;
                if (checkoutForm.description) {
                    message += `*Notes:* ${checkoutForm.description}\n`;
                }

                message += `\n*Products:*\n`;

                products.forEach((p, index) => {
                    message += `\n${index + 1}. *${p.product_name}*\n`;
                    message += `   - SKU: ${p.product_sku}\n`;
                    message += `   - Price: ₹${p.product_price}\n`;
                    message += `   - Offer: ₹${p.product_saleprice}\n`;
                    if (p.product_image) {
                        message += `   - Image: ${url}${p.product_image}\n`;
                    }
                });

                // message += `\n*Total Before Discount:* ₹${payload.totalBeforeDiscount}\n`;
                message += `*Discount:* ₹${discount}\n`;
                message += `*Total Payable:* ₹${payload.amountafterdiscount}\n`;
                if (couponCode) {
                    message += `*Coupon Used:* ${couponCode}\n`;
                }

                // ✅ WhatsApp redirect
                const encodedMsg = encodeURIComponent(message);
                const whatsappUrl = `https://wa.me/${whatsAppNumber}?text=${encodedMsg}`;
                window.open(whatsappUrl, "_blank");
            }

            setLoading(false)
        } catch (error) {
            setLoading(false)
        }
    }


    const CartEmpty = async () => {
        try {
            const response = await fetch(`${url}/cart/deleteall/${userData.user_id}`, {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json"
                }
            })
            const res = await response.json();
            if (response.ok) {
                localStorage.removeItem("checkout_data");
                await fetchCart1(userData?.user_id)
                setTimeout(() => {
                    navigate("/my-account"); // 👈 Redirect to home after 2 seconds
                }, 2000);
            }
        } catch (error) {
            console.error(error)
        }
    }



    const [triggerShake, setTriggerShake] = useState(false);

    useEffect(() => {
        if (products.length === 0) {
            setTriggerShake(true);
            const timeout = setTimeout(() => setTriggerShake(false), 700); // remove class after animation ends
            return () => clearTimeout(timeout);
        }
    }, [products]);




    const handleCheckout = () => {
        if (!products || products.length === 0) {
            toast.warn("Your cart is empty!");
            return;
        }

        const totalSalePrice = products.reduce((acc, p) => acc + Number(p.product_saleprice), 0);
        const totalBeforeDiscount = products.reduce((acc, p) => acc + Number(p.product_price), 0);
        const totalAfterDiscount = (totalSalePrice - discount).toFixed(2);

        const checkoutDetails = {
            products,
            coupon: couponCode || null,
            discountAmount: discount,
            totalBeforeDiscount: totalBeforeDiscount,
            totalAfterDiscount,
            isCouponApplied: !!discount,
        };

        localStorage.setItem("checkout_data", JSON.stringify(checkoutDetails));
        if (userData) {
            navigate("/checkout");
        } else {
            navigate("/login");
            sessionStorage.setItem("navigatepage", "/checkout");
        }
    };

    const handleSubmitQuote = (e) => {
        e.preventDefault();
        setShowCheckoutModal(false);
        if (userData) {
            handleAskQuote();
        } else {
            navigate("/login");
            sessionStorage.setItem("navigatepage", "/cart");
        }
    }

    const getDefaultCartButton = () => {
        const isGetQuoteDefault = paybutton.find(b => b.button_id === 'paymanual' && b.default);
        if (isGetQuoteDefault) return 'paymanual';

        const isAddToCartDefault = paybutton.find(b => b.button_id === 'paynow' && b.default);
        if (isAddToCartDefault) return 'paynow';

        const isBuyNowDefault = paybutton.find(b => b.button_id === 'payondelivery' && b.default);
        if (isBuyNowDefault) return 'payondelivery';

        return null; // fallback
    };
    const defaultButtonPay = getDefaultCartButton();



    return (
        <>
            <ToastContainer position="top-center" autoClose={3000} />
            <div className="cart-perfume">
                <div className="cart-perfume-header">Your cart</div>
                <div className="cart-columns-perfume">
                    <div className="cart-column1-perfume">
                        <div
                            className="cart-column1-coupon-perfume"
                            onClick={() => setIsOpen(true)}

                        >
                            <i className="fa-solid fa-ticket"></i> Apply Coupon
                        </div>
                        {products.length === 0 ? (
                            <div className="empty-cart-container">
                                <img src={EmptyCartImg} alt="Empty Cart" className={`empty-cart-image ${triggerShake ? 'shake-animation' : ''}`} />
                                <div>
                                    <p className='emptyecom-cart-container'>Your Cart is Empty!</p>
                                    <button className="empty-cart-buy-now" onClick={() => navigate("/course")}>
                                        Buy Now
                                    </button>
                                </div>
                            </div>
                        ) :
                            (products.map((product) => (
                                <div key={product.id} className="cart-column1-product-perfume">
                                    <div className="cart-product-card-perfume cart-product-img">
                                        <img src={`${url}${product.product_image}`} alt={product.name} />
                                    </div>
                                    <div className="cart-product-card-perfume cart-product-details">
                                        <div className="cart-product-details-column1">
                                            <h3>{product.product_name}</h3>
                                            {product.delivery_days ? (
                                                <p className="cart-delivery-time">
                                                    Delivery by <strong>{getDeliveryDate(product.delivery_days)}</strong>
                                                </p>
                                            ) : null}



                                            {product.variation_attributes && Object.entries(product.variation_attributes).map(([key, value]) => (
                                                <p key={key}><strong>{key}:</strong> {value}</p>
                                            ))}

                                            <button className="cart-remove-product" onClick={() => handleRemoveProduct(product.product_sku)}>
                                                <i className="fa-solid fa-trash"></i> Remove
                                            </button>

                                        </div>
                                        <div className="cart-product-details-column2">
                                            <h3 className="cart-discount-price"><strong>₹{Number(product.product_saleprice).toFixed(2)}</strong></h3>
                                            <p className="cart-original-price">₹{Number(product.product_price).toFixed(2)}</p>
                                        </div>
                                    </div>
                                </div>
                            )))}
                    </div>
                    <div className="cart-column2-perfume">
                        <div className="cart-column2-header-perfume">
                            <h3>Order summary ({products.length} items)</h3>
                        </div>
                        <div className="cart-column2-total-perfume">
                            <div className="cart-total-labels">
                                <p><strong>Total Price</strong></p>
                                <p>Original Price</p>
                            </div>
                            <div className="cart-total-value">
                                {/* <p><strong>₹{(products.reduce((acc, p) => acc + Number(p.product_price), 0) - discount).toFixed(2)}</strong></p> */}

                                <p><strong>₹{(products.reduce((acc, p) => acc + Number(p.product_saleprice), 0) - discount).toFixed(2)}</strong></p>
                                <p>₹{(products.reduce((acc, p) => acc + Number(p.product_price), 0)).toFixed(2)}</p>
                            </div>
                        </div>
                        {
                            defaultButtonPay === "paymanual" ? <div className="cart-checkout-btn" onClick={() => {
                                if (products.length === 0) {
                                    toast.warn("Your cart is empty!");
                                    return;
                                }
                                setShowCheckoutModal(true);
                            }}>
                                <button className="cart-checkout-btn" >Checkout</button>
                            </div> : <div className="cart-checkout-btn" onClick={handleCheckout}>
                                <button className="cart-checkout-btn" >Checkout</button>
                            </div>
                        }
                        {/* <div className="cart-checkout-btn" onClick={handleCheckout}>
                            <button className="cart-checkout-btn" >Checkout</button>
                        </div> */}
                    </div>
                </div>
            </div>

            {isOpen && (
                <div className="coupon-modal">
                    <div className="coupon-modal-content">
                        <span className="coupon-close" onClick={() => setIsOpen(false)}><i className="fa-solid fa-xmark"></i></span>
                        <h3 className="coupon-title">Apply Coupon</h3>
                        <input
                            type="text"
                            className="coupon-input"
                            placeholder="Enter Coupon Code"
                            value={couponCode}
                            onChange={(e) => setCouponCode(e.target.value)}
                        />
                        <button className="coupon-apply-btn" onClick={applyCoupon} >
                            Apply Coupon
                        </button>
                    </div>
                </div>
            )}
            {showCheckoutModal && (
                <div className="checkout-modal-overlay">
                    <div className="checkout-modal-content">
                        <div className="group-modal-header">
                            <h3>Enter Guest Details</h3>
                            <span className="checkout-close" onClick={() => setShowCheckoutModal(false)}>
                                <i className="fa-solid fa-xmark"></i>
                            </span>
                        </div>
                        <form className="checkout-form" onSubmit={handleSubmitQuote}>
                            <div className="checkout-form-group">
                                <label htmlFor="name">Full Name</label>
                                <input
                                    id="name"
                                    type="text"
                                    placeholder="Full Name"
                                    value={checkoutForm.name}

                                    onChange={(e) => setCheckoutForm(prev => ({ ...prev, name: e.target.value }))}
                                    required
                                />
                            </div>

                            <div className="checkout-form-group">
                                <label htmlFor="mobile">Phone Number</label>
                                <input
                                    id="mobile"
                                    type="tel"
                                    placeholder="Phone Number"
                                    value={checkoutForm.mobile}
                                    onChange={handleMobileChange}
                                    required
                                />
                                {mobileError && (
                                    <p className='hbtecom-mobileerror' >{mobileError}</p>
                                )}
                            </div>

                            <div className="checkout-form-group">
                                <label htmlFor="email">Email Address</label>
                                <input
                                    id="email"
                                    type="email"
                                    placeholder="Email Address"
                                    value={checkoutForm.email}
                                    onChange={(e) => setCheckoutForm(prev => ({ ...prev, email: e.target.value }))}
                                />
                            </div>


                            <div className="checkout-form-group">
                                <label htmlFor="description">Description</label>
                                <input
                                    id="description"
                                    type="text"
                                    placeholder="Description"
                                    value={checkoutForm.description}
                                    onChange={(e) => setCheckoutForm(prev => ({ ...prev, description: e.target.value }))}
                                />
                            </div>
                            {
                                loading ? <button
                                    type="button"
                                    className="checkout-submit-btn"
                                >
                                    Loading...
                                </button> : <button
                                    type="submit"
                                    className="checkout-submit-btn"

                                >
                                    Proceed to Checkout
                                </button>
                            }
                        </form>
                    </div>
                </div>
            )}
        </>
    );
};

export default Cart;